import React, { Component } from 'react';
import './App.css';
import {getData} from './util';
import Map from './glmap';

//https://dev.to/gaels/an-alternative-to-handle-global-state-in-react-the-url--3753
function getParams(location) {
  const searchParams = new URLSearchParams(location.search);
  return {
    field: searchParams.get('f') || 0,
  };
}

class App extends Component {
  constructor(props){
    super(props);
    this.state={gj:undefined,binary:true};
  }
  componentDidMount(){
    getData('map.gj',(gj)=>{
      // console.log(gj);
      let mins={};
      let maxs={};
      for (let i=0;i<gj.features.length;i++){
        for (let f in gj.features[i].properties){
          let p=gj.features[i].properties;
          if (!mins.hasOwnProperty(f)){
            mins[f]=p[f];
            maxs[f]=p[f];
          }else{
            mins[f]=Math.min(mins[f],p[f]);
            maxs[f]=Math.max(maxs[f],p[f]);
          }
        }
      }
      let params=getParams(window.location);
      console.log(mins,maxs);
      this.setState({gj:gj,mins:mins,maxs:maxs,f:params.field,k:'flat'});
    })

  }

//   Certified Pizza: 0
// City: "Willowbrook"
// Pizza: 1
// Religious: 5
// Restaurants (ALL): 9
// Starbucks: 1
// Sushi: 0
// Thai: 0
// Zip: "90222"
  
  render() {
    // let fields=["Religious","Restaurants (ALL)","Starbucks","Pizza","Sushi","Thai","Certified Pizza","Mexican","Bar B Que","Chinese"];
    let fields=["Restaurants (ALL)","Mexican","Chinese"];
    let binary=[false,true,true];

    let jsx=[];
    console.log('app state',this.state);

    if (this.state.mins!==undefined){      
      for(let i=0;i<fields.length;i++){
        let f=fields[i];

        jsx.push(
          <div key={f} style={{display:'block'}}>
            <div>
              <h3>{f}</h3>
            </div>
            <div className="map">
                <Map 
                  geojson={this.state.gj}
                  field={f}
                  colour={binary[i]?[0,'black',1,'red']:
                    [this.state.mins[f],'black',this.state.maxs[f],'red']}
                  // exHeight={[this.state.mins[f],0,this.state.maxs[f],2000]}
                />
            </div>
          </div>);      
      }
    }

      return (
      <div className="App">
        {jsx}
      </div>
    );
  }
}

export default App;
